import { trpc } from "../trpc";

export function useMeQuery() {
  const meQuery = trpc.viewer.me.get.useQuery(undefined, {
    retry(failureCount, error) {
      if ((error as any)?.data?.httpStatus === 401) return false;
      return failureCount < 3;
    },
  });

  return meQuery;
}

export default useMeQuery;
